module.exports = __webpack_public_path__ + "static/media/german_engineers2.61f3feb9.jpg";